const DEFAULT_BACKEND_PORT = '9200'

function trimTrailingSlash(value: string): string {
  return value.replace(/\/+$/, '')
}

function getWindowBackendUrl(): string {
  if (typeof window === 'undefined') return ''

  const { protocol, hostname, port, origin } = window.location

  // The game frontend is served on :9201 in the current deployment and Vite
  // uses :3000 locally. In both cases the backend websocket listens on :9200.
  if (port === '9201' || port === '3000' || port === '5173') {
    return `${protocol}//${hostname}:${DEFAULT_BACKEND_PORT}`
  }

  return origin
}

function absoluteFromWindow(value: string): string {
  if (/^https?:\/\//i.test(value)) return trimTrailingSlash(value)
  if (typeof window === 'undefined') return trimTrailingSlash(value)

  if (value.startsWith('/')) return trimTrailingSlash(`${window.location.origin}${value}`)
  return trimTrailingSlash(`${window.location.origin}/${value}`)
}

export function getBackendBaseUrl(): string {
  const explicit = import.meta.env.VITE_WINNERY_API_URL || ''
  if (explicit) return absoluteFromWindow(explicit)

  const inferred = getWindowBackendUrl()
  if (inferred) return trimTrailingSlash(inferred)

  const legacy = import.meta.env.VITE_API_URL || ''
  return legacy ? absoluteFromWindow(legacy) : ''
}

export function getGameWsBaseUrl(): string {
  const explicit = import.meta.env.VITE_GAME_WS_URL || ''
  if (explicit) return absoluteFromWindow(explicit)

  return getBackendBaseUrl()
}
